import React, { useState } from 'react';
import BEMHelper from '@ynap/bem-helper';
import Overlay from "@ynap/overlay";
import { useMessages, useAppState } from '@ynap/immutables-provider';

type PremierDeliveryNotificationProps = {
    className?: string;
};

const bem = new BEMHelper('PremierDeliveryNotification');

const PremierDeliveryModal = ({ modalText }) => {
    return (
        <div className={bem('modalContainer')}>
            <div className={bem('modalContent')}>
                <span>{modalText}</span>
            </div>
        </div>
    );
};

const PremierDeliveryNotification = ({ className }: PremierDeliveryNotificationProps) => {
    const { premierDelivery = {} } = useMessages();
    const { country } = useAppState() || {};
    const [showOverlay, setShowOverlay] = useState<boolean>();
    const notificationLinkText = premierDelivery?.notificationLinkText();
    const notificationTrailingText = premierDelivery?.notificationTrailingText({ country });
    const modalTitle = premierDelivery?.modalTitle() || '';
    const modalText = premierDelivery?.modalText({ country }) || '';

    if (!notificationLinkText || !notificationTrailingText) return null;

    return (
        <p className={bem('', className)}>
            <div className={bem('text')}>
                <span className={bem('link')} onClick={() => setShowOverlay(true)}>{notificationLinkText}</span>
                <span>{notificationTrailingText}</span>
            </div>
            {
                showOverlay && (
                    <Overlay
                        title={modalTitle}
                        className={{ container: bem('overlay'), title: bem('title'), content: bem('content'), button: bem('close') }}
                        onClose={() => setShowOverlay(false)}
                    >
                        <PremierDeliveryModal modalText={modalText} />
                    </Overlay>
                )
            }
        </p>
    );
};



export default PremierDeliveryNotification;
